<template>
  <div class="vl-personal-main">
    <ul class="menuUl">
      <div class="company">
        <img
          src="../../../../assets/img/personalCenter/companyImg.png"
          alt=""
        />
        <div class="name">{{ companyInfo.companySimpleName }}</div>
        <div class="email">{{ companyInfo.companyEmail }}</div>
      </div>
      <el-menu
        :default-active="activeIndex"
        active-text-color="#4286F5"
        text-color="#333333"
        @select="jumpMenu"
      >
        <el-menu-item
          :index="item.id"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <span slot="title">
            <i
              class="iconfont"
              :class="item.icon"
              style="
                vertical-align: baseline;
                font-size: 20px;
                margin-right: 5px;
              "
            ></i>
            {{ item.name }}
          </span>
        </el-menu-item>
      </el-menu>
    </ul>
    <div class="tableCont" v-show="activeIndex === '1'">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="接入中" name="1">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="appName"
              label="应用名称"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appTypeName"
              label="应用分类"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appTerminalTypeName"
              label="应用端口"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appKey"
              label="App Key"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appStatusName"
              label="当前状态"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" min-width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.manage"
                  @click="goToAppManage('appManegeAppConfig', scope.row.appId)"
                  >管理</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.update"
                  @click="applyOnline(scope.row.appId)"
                  >修改
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.applyOnline"
                  @click="applyOnline(scope.row.appId)"
                  >申请上线
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.module"
                  @click="componentManage(scope.row.appId)"
                  >组件管理
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.view"
                  @click="goToAppManage('appManegeAppDetail', scope.row.appId)"
                  >查看
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.scope"
                  @click="
                    goToAppManage('appManegeAppOpenSearch', scope.row.appId)
                  "
                  >开通查询
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="pagination.total > 0"
            background
            layout="prev, pager, next"
            :current-page.sync="pagination.pageNo"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            :page-size.sync="pagination.pageSize"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="已上线" name="2">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="appName"
              label="应用名称"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appTypeName"
              label="应用分类"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appTerminalTypeName"
              label="应用端口"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appKey"
              label="App Key"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appStatusName"
              label="当前状态"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" min-width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.manage"
                  @click="goToAppManage('appManegeAppConfig', scope.row.appId)"
                  >管理
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.applyOnline"
                  @click="applyOnline(scope.row.appId)"
                  >申请上线
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.module"
                  @click="componentManage(scope.row.appId)"
                  >组件管理
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.view"
                  @click="goToAppManage('appManegeAppDetail', scope.row.appId)"
                  >查看
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.scope"
                  @click="
                    goToAppManage('appManegeAppOpenSearch', scope.row.appId)
                  "
                  >开通查询
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="pagination.total > 0"
            background
            layout="prev, pager, next"
            :current-page.sync="pagination.pageNo"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            :page-size.sync="pagination.pageSize"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="已下线" name="3">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="appName"
              label="应用名称"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appTypeName"
              label="应用分类"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appTerminalTypeName"
              label="应用端口"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appKey"
              label="App Key"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="appStatusName"
              label="当前状态"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" min-width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.manage"
                  @click="goToAppManage('appManegeAppConfig', scope.row.appId)"
                  >管理
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.applyOnline"
                  @click="applyOnline(scope.row.appId)"
                  >申请上线
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.view"
                  @click="goToAppManage('appManegeAppDetail', scope.row.appId)"
                  >查看
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.operation.scope"
                  @click="
                    goToAppManage('appManegeAppOpenSearch', scope.row.appId)
                  "
                  >开通查询
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="pagination.total > 0"
            background
            layout="prev, pager, next"
            :current-page.sync="pagination.pageNo"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            :page-size.sync="pagination.pageSize"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="tableCont" v-show="activeIndex === '2'">
      <p class="inAll">
        共<span style="color: #666666"> {{ mesPagination.total }} </span>条消息
      </p>
      <el-table :data="mesTableData" style="width: 100%">
        <el-table-column
          prop="messageTypeName"
          label="消息类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          width="500"
          prop="messageContent"
          show-overflow-tooltip
          label="消息内容"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="发送时间"
          width="170"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="delMes(scope.row.messageId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="mesPagination.total > 0"
        background
        layout="prev, pager, next"
        :current-page.sync="mesPagination.pageNo"
        :total="mesPagination.total"
        @current-change="mesHandleCurrentChange"
        :page-size.sync="mesPagination.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  PersonalPostAppList,
  PersonalPostMessageList,
  PersonalGetDeleteMessage,
  PersonalGetAppOnlineCheck,
} from "@/views/index/api/personalCenter/api.personalCenter.js";
export default {
  data() {
    return {
      pagination: {
        total: 10,
        pageNo: 1,
        pageSize: 10,
      },
      mesPagination: {
        total: 10,
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      mesTableData: [],
      activeName: "1",
      activeIndex: "1",
      menuList: [
        {
          name: "我的应用",
          id: "1",
          icon: "icon-Leftsidebar_Myapp",
        },
        {
          name: "消息通知",
          id: "2",
          icon: "icon-Leftsidebar_Messagenotification",
        },
      ],
    };
  },
  mounted() {
    this.getData();
    this.getMesData();
  },
  computed: {
    companyInfo() {
      let obj = {
        companyEmail: this.$store.state.loginUser.companyEmail,
        companySimpleName: this.$store.state.loginUser.companySimpleName,
      };
      obj.companyEmail = obj.companyEmail.replace(
        obj.companyEmail.substring(3, obj.companyEmail.indexOf("@")),
        "****"
      );
      return obj;
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getData();
    },
    // 获取数据
    getData() {
      this.tableData = [];
      let params = {
        appStatus: this.activeName,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
      };
      PersonalPostAppList(params).then((res) => {
        if (res && res.result) {
          this.tableData = res.result.list;
          this.pagination.total = res.result.totalNum;
          console.log(this.pagination);
        } else {
          this.tableData = [];
        }
      });
    },
    // 菜单跳转
    jumpMenu(index) {
      this.activeIndex = index;
    },
    handleClick() {
      this.getData();
    },
    applyOnline(appId) {
      PersonalGetAppOnlineCheck({ appId }).then((res) => {
        if (res) {
          this.goToAppManage("personAppPublish", appId);
        } else {
          this.goToAppManage("appManegeAppConfig", appId);
        }
      });
    },
    goToAppManage(routeName, appId) {
      this.$router.push({ name: routeName, query: { appId } });
    },

    mesHandleCurrentChange(val) {
      this.mesPagination.pageNo = val;
      this.getMesData();
    },
    delMes(id) {
      this.$confirm("确认删除该消息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          messageId: id,
        };
        PersonalGetDeleteMessage(params).then((res) => {
          if (res) {
            this.$MyMessage("删除成功", "success");
            this.getMesData();
          }
        });
      });
    },
    // 获取数据
    getMesData() {
      let params = {
        pageNo: this.mesPagination.pageNo,
        pageSize: this.mesPagination.pageSize,
      };
      PersonalPostMessageList(params).then((res) => {
        if (res && res.result) {
          this.mesTableData = res.result.list;
          this.mesPagination.total = res.result.totalNum;
        } else {
          this.mesTableData = [];
        }
      });
    },

    /**
     * 组件管理
     * */
    componentManage(appId) {
      this.$router.push({ name: "compManageList", query: { appId } });
    },
  },
};
</script>
<style lang="scss">
.vl-personal-main {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 20px;
  min-height: 857px;
  .el-pagination {
    text-align: center;
    margin: 30px 0 50px;
  }
  .el-pagination.is-background .el-pager li {
    color: #666 !important;
    font-weight: normal;
    font-size: 14px;
    background-color: #f6f7f8 !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #4286f5 !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4286f5 !important;
    color: #fff !important;
  }
  .menuUl {
    width: 250px;
    /* box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.1); */
    border: 1px solid #ebeef5;
  }
  .menuUl > .company {
    /* height: 230px; */
    background: url(../../../../assets/img/menuBg.png) no-repeat center;
    background-size: 100% 100%;
    text-align: center;
  }
  .menuUl > .company > img {
    display: inline-block;
    margin: 40px 0 20px 0;
  }
  .menuUl > .company > div {
    text-align: center;
  }
  .menuUl > .company > .name {
    font-size: 18px;
    color: #0059b2;
    font-weight: bold;
  }
  .menuUl > .company > .email {
    font-size: 16px;
    color: #333;
    padding-top: 10px;
    padding-bottom: 15px;
  }
  .menuUl .el-menu {
    border-right: none !important;
  }
  .menuUl .el-menu-item {
    font-size: 18px !important;
    height: 50px !important;
    line-height: 50px !important;
    padding-left: 50px !important;
    transition: background-color 0.3s, color 0.3s !important;
  }
  .menuUl .el-menu-item.is-active,
  .el-menu-item:hover {
    background-color: #f1f8ff !important;
  }
  .menuUl .el-menu-item.is-active {
    border-bottom: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    position: relative;
  }
  .menuUl .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 50px;
    background-color: #4286f5;
    left: 0;
    top: -1px;
  }

  .tableCont {
    width: calc(100% - 250px);
    padding: 40px 40px 50px;
    /* box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.1); */
    border: 1px solid #ebeef5;
    border-left: none;
    .inAll {
      padding-bottom: 30px;
    }
  }
}
</style>